import request from '../utils/request'

export const listCustomerGroups = () => request({ url: '/admin/user-groups', method: 'GET', params: { includeEmpty: true }, silentError: true })
export const createCustomerGroup = name => request({ url: '/admin/user-groups', method: 'POST', data: { name }, silentError: true })
export const assignCustomerGroup = (groupId, userIds) => request({ url: '/admin/user-groups/members', method: 'PUT', data: { groupId, userIds }, silentError: true })

export const deleteCustomerGroup = groupId => request({ url: `/admin/user-groups/${encodeURIComponent(groupId)}`, method: 'DELETE', silentError: true })
